import * as TypeGraphQL from "type-graphql";
export var ArtifactType;
(function (ArtifactType) {
    ArtifactType["WEIGHTS"] = "WEIGHTS";
    ArtifactType["MODEL_FILE"] = "MODEL_FILE";
    ArtifactType["PREPROCESSOR"] = "PREPROCESSOR";
    ArtifactType["FEATURE_TRANSFORMER"] = "FEATURE_TRANSFORMER";
    ArtifactType["ENSEMBLE_CONFIG"] = "ENSEMBLE_CONFIG";
})(ArtifactType || (ArtifactType = {}));
TypeGraphQL.registerEnumType(ArtifactType, {
    name: "ArtifactType",
    description: undefined,
});
//# sourceMappingURL=ArtifactType.js.map